module.exports = __webpack_public_path__ + "./fonts/IRANSansWeb_FaNum.ttf";